module.exports = __webpack_public_path__ + "static/deslizadero-f823dc15290deb10a0b854fe58314f8d.png";